// Renders the active confirmDialog() request as a themed modal — the styled
// replacement for native window.confirm(). Mounted once in Layout next to
// ToastHost.

import { useEffect, useRef } from "preact/hooks";
import { Modal } from "./Modal";
import { confirmSignal } from "../lib/confirm";

export function ConfirmDialogHost(): preact.JSX.Element | null {
  const req = confirmSignal.value;
  const confirmRef = useRef<HTMLButtonElement>(null);

  // Focus the primary action so Enter confirms and Tab reaches Abbrechen.
  useEffect(() => {
    if (req) confirmRef.current?.focus();
  }, [req?.id]);

  if (!req) return null;

  return (
    <Modal title={req.title ?? "Bestätigen"} onClose={() => req.resolve(false)} size="sm">
      <p class="text-sm text-[color:var(--color-on-surface)] whitespace-pre-wrap">{req.message}</p>
      <div class="mt-5 flex justify-end gap-2">
        <button
          type="button"
          onClick={() => req.resolve(false)}
          class="rounded border border-[color:var(--color-outline-variant)] px-3 py-1.5 text-sm text-[color:var(--color-on-surface)] hover:bg-[color:var(--color-surface-container-low)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-primary)] focus-visible:ring-offset-2 transition-colors"
        >
          {req.cancelLabel ?? "Abbrechen"}
        </button>
        <button
          type="button"
          ref={confirmRef}
          onClick={() => req.resolve(true)}
          class={`rounded px-3 py-1.5 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 transition-colors ${
            req.danger
              ? "bg-[color:var(--color-error)] text-[color:var(--color-on-error)] hover:opacity-90 focus-visible:ring-[color:var(--color-error)]"
              : "bg-[color:var(--color-primary)] text-[color:var(--color-on-primary)] hover:bg-[color:var(--color-primary-strong)] focus-visible:ring-[color:var(--color-primary)]"
          }`}
        >
          {req.confirmLabel ?? "OK"}
        </button>
      </div>
    </Modal>
  );
}
